import React, { ReactNode } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PlanEditStore } from './plan-edit.store';

const PlanEditContext = React.createContext<PlanEditStore | null>(null);

export const PlanEditProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const { slug = '' } = useParams();
   const [store] = React.useState<PlanEditStore>(() => new PlanEditStore(slug, navigate));

   return <PlanEditContext.Provider value={store}>{children}</PlanEditContext.Provider>;
};

export const usePlanEdit = () => {
   const ctx = React.useContext(PlanEditContext);
   if (!ctx) {
      throw new Error('usePlanEdit must be used inside PlanEditProvider');
   }
   return ctx;
};
